import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

/**
 * 진입점 - 홈으로 리다이렉트 (가칭 무용연)
 *  ★ 2026-11-02 주소 뒤 파라미터(?lp=·utm_*·fbclid)를 그대로 넘긴다. 종전엔 /home 으로 바꾸며 버려서,
 *   늦게 받아지는 Meta 픽셀 스크립트가 fbclid 를 못 읽어 광고 클릭 ID(_fbc)가 비었다
 *   → '등록 완료' 최적화 캠페인이 가입자를 광고와 잇지 못한다.
 */
export default function Start() {
  const navigate = useNavigate();
  const { search, hash } = useLocation();
  useEffect(() => {
    navigate(`/home${search || ""}${hash || ""}`, { replace: true });
  }, [navigate, search, hash]);
  return null;
}
